export const FETCH_MENU_DAYS = "FETCH_MENU_DAYS";
